// extracted by mini-css-extract-plugin
export default {"def":"_type_def__jMnED","dense":"_type_dense__96Rnu"};